import { colors, spacing } from '@moderneinc/design-system-tokens';
import { Box, keyframes } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { FunctionComponent } from 'react';

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 ${alpha(colors.red['500'], 0.6)}; }
  70% { box-shadow: 0 0 0 ${spacing.spacing_3_4}px ${alpha(colors.red['500'], 0)}; }
  100% { box-shadow: 0 0 0 0 ${alpha(colors.red['500'], 0)}; }
`;

export const ProfilingIndicatorDot: FunctionComponent = () => {
  return (
    <Box
      aria-hidden="true"
      sx={{
        width: spacing.spacing_1,
        height: spacing.spacing_1,
        borderRadius: '50%',
        backgroundColor: colors.red['500'],
        animation: `${pulse} 1.6s ease-out infinite`,
        flexShrink: 0
      }}
    />
  );
};
